
export const url = {
  getLastUpdateTime: '/auth/trade/lastUpdateTime',
  findList: '/auth/trade/web/findList',
  getDetail: '/auth/trade/findWebDetail',
  addToCart: '/auth/trade/shoppingCart/add',
  getCartCount: '/auth/trade/shoppingCart/count',
  getCartList: '/auth/trade/shoppingCart/list',
  removeCart: '/auth/trade/shoppingCart/remove',
  submitCart: '/auth/trade/shoppingCart/submit',
  applyForBasfProductTabAuth: '/auth/user/applyForBasfProductTabAuth'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/basfProductClient.js